<template>
  <div class="login-wrapper">
    <div class="login-card">
      <!-- LEFT: Login Form -->
      <div class="login-form">
        <div class="text-center mb-3">
          <img
            src="/signup-img/boston-img.png"
            alt="Boston Logo"
            class="img-fluid logo"
          >
        </div>
        <h2 class="main-heading">Welcome to Boston College's Food & Beverage Training Platform.</h2>
        <p class="text-center">Select which role best describes your employment.</p>
        <!-- <p class="subtitle">Use your credentials to login</p> -->

                  <div class="generic-layout my-4">
   <div class="ac-selection-wrap mb-4">
            <div class="acc-type-wrap row">
              <div class="col-md-6 mb-3 mb-md-0">
                <router-link to="">
                  <div
                    :disabled="active === 4"
                    class="ac-type-block border rounded-4 p-5 text-center position-relative"
                    style="cursor: pointer;border-radius: 0.5rem;"
                  >
                    <span class="active-tick"><img src="img/price/orange-tick.svg" alt=""></span>
                    <img src="/signup-img/part_time.svg" width="20%" class="img-fluid" alt="" />
                    <h3 class="fw-bold mt-2">Temporary (Event Staff)</h3>
                      <p class="lh-sm mt-2">
                   You are registering as a temporary event staff at Boston College
                 </p>
                    <!-- Add "New User" description here -->
                  </div>
                </router-link>
              </div>
              <div class="col-md-6">
                <router-link to="">
                  <div
                    :disabled="active === 4"
                    class="ac-type-block border rounded-4 p-5 text-center position-relative"
                    style="cursor: pointer;border-radius: 0.5rem;"
                  >
                    <span class="active-tick"><img src="img/price/orange-tick.svg" alt=""></span>
                    <img src="/signup-img/full_time.svg" width="20%" class="img-fluid"  alt="" />
                    <h3 class="fw-bold mt-2">Permanent</h3>
                    <!-- Add "New Company" description here -->
                    <p class="lh-sm mt-2">
                     You are registering as a permanent employee at Boston College.
                      </p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div v-if="errors.invalid" class="alert alert-danger">
          {{ errors.invalid }}
        </div>
      </div>

      <!-- RIGHT: Info + Video -->

    </div>

    <!-- Custom Video Modal -->
    <div v-if="showVideoModal" class="video-modal-overlay" @click="closeModal">
      <div class="video-modal-content" @click.stop>
        <button class="modal-close-btn" @click="closeModal">&times;</button>
        <div class="video-container">
          <iframe
            :src="videoSrc"
            title="Boston College Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>

    <!-- <the-footer/> -->
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
// import TheFooter from '@/boston/partials/Footer.vue';

export default {
  name: 'BostonLogin',
  components: {
    // TheFooter,
  },
  data() {
    return {
      loading: false,
      showVideoModal: false,
      form: {
        username: "",
        password: "",
      },
      errors: {
        invalid: "",
      },
      siteName: "",
      year: new Date().getFullYear(),
    };
  },
  computed: {
    videoSrc() {
      // return this.showVideoModal
      //   ? "https://www.youtube.com/watch?v=5-_uYyVlxrk?autoplay=1"
      //   : "https://www.youtube.com/embed/5-_uYyVlxrk?autoplay=0";

        return this.showVideoModal
        ? "https://www.youtube.com/embed/5-_uYyVlxrk?autoplay=1"
        : "https://www.youtube.com/embed/5-_uYyVlxrk?autoplay=0";
    }
  },
  mounted() {
    document.querySelector('title').textContent = "Boston College LMS";

    // Handle escape key to close modal
    document.addEventListener('keydown', this.handleEscapeKey);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscapeKey);
  },
  created() {
    if (this.$route.query.email && this.$route.query.password) {
      this.form.username = this.$route.query.email;
      this.form.password = this.$route.query.password;
      this.onSubmit();
    }
    this.siteName = 'Boston-Login';
  },
  methods: {
    closeModal() {
      this.showVideoModal = false;
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.showVideoModal) {
        this.closeModal();
      }
    },
    onSubmit() {
      this.loading = true;
      this.errors.invalid = "";

      this.$http
        .post("user/login", {
          email: this.form.username,
          password: this.form.password,
        })
        .then((resp) => {
          localStorage.setItem("hot-token", resp.data.token);
          localStorage.setItem("hot-user", resp.data.role);
          localStorage.setItem("hot-logged-user", resp.data.user_id);
          localStorage.setItem("hot-user-full-name", resp.data.full_name);

          let headers = {
            authorization: "Bearer " + resp.data.token,
            "content-type": "application/json",
          };
          this.$http.defaults.headers.authorization = "Bearer " + resp.data.token;

          let admin = "";

          switch (resp.data.role) {
            case "super-admin":
              admin = "super_admin";
              localStorage.setItem("hot-sidebar", admin);
              this.$http
                .post("company/managerdata", { email: this.form.username }, { headers })
                .then((resp) => {
                  localStorage.setItem("hot-user-id", resp.data[0].id);
                  this.$router.push("/dashboard");
                });
              break;

            case "company-admin":
              admin = "admin";
              localStorage.setItem("hot-sidebar", admin);
              this.$http
                .post("company/data", { email: this.form.username }, { headers })
                .then((resp) => {
                  if (resp.data.level) {
                    localStorage.setItem("hot-company-level", "parent");
                  } else {
                    localStorage.setItem("hot-company-level", "child");
                  }
                  localStorage.setItem("hot-admin-id", resp.data.admin_id);
                  localStorage.setItem("hot-user-id", resp.data[0].id);
                  localStorage.setItem("hot-company-name", resp.data[0].name);
                  this.$router.push("/dashboard");
                });
              break;

            case "manager":
              admin = "manager";
              localStorage.setItem("hot-sidebar", admin);
              this.$http
                .post("company/managerdata", { email: this.form.username }, { headers })
                .then((resp) => {
                  localStorage.setItem("hot-user-id", resp.data[0].id);
                  localStorage.setItem("hot-user-name", resp.data[0].full_name);
                  localStorage.setItem("hot-user-number", resp.data[0].phone_num);
                  localStorage.setItem("hot-user-2fa", resp.data[0].is_2f_authenticated);
                  this.$router.push("/dashboard");
                });
              break;

            case "employee":
              admin = "employee";
              localStorage.setItem("hot-sidebar", admin);
              this.$http
                .post("employees/user_data", { user_name: this.form.username }, { headers })
                .then((resp) => {
                  localStorage.setItem("hot-user-id", resp.data[0].id);
                  localStorage.setItem("hot-user-name", resp.data[0].full_name);
                  localStorage.setItem("hot-user-number", resp.data[0].phone_num);
                  localStorage.setItem("hot-user-2fa", resp.data[0].is_2f_authenticated);
                  if (resp.data[0].employee_status == 0) {
                    this.errors.invalid = "Account is Deactivated by Admin..!!";
                  } else {
                    this.$router.push("/dashboard");
                  }
                });
              break;

            case "sub-admin":
              admin = "sub_admin";
              localStorage.setItem("hot-sidebar", admin);
              this.$http
                .post("company/managerdata", { email: this.form.username }, { headers })
                .then((resp) => {
                  localStorage.setItem("hot-user-id", resp.data[0].id);
                  this.$router.push("/dashboard");
                });
              break;

            default:
              this.errors.invalid = "Not Valid..!!";
          }
        })
        .catch((error) => {
          let errorText = "Something went wrong! Please try again later.";
          if (error.response && error.response.status === 422) {
            errorText = error.response.data.message;
          }

          Swal.fire({
            title: "Error!",
            html: errorText,
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.login-wrapper:before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: hsl(0deg 0% 0% / 41%) !important;
}

.login-wrapper {
  min-height: 100vh;
  font-family: 'Nunito', sans-serif;
  background: url('/boston/loginbg.jpg') no-repeat center/cover;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  position: relative;
}
.main-heading {
  font-size: 1.75rem;
  color: black;
  font-weight: 700;
  margin-bottom: 0.5rem;
}
.login-wrapper::before {
  content: "";
  position: absolute;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.1);
}

.login-card {
  max-width: 900px;
  width: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 0.5rem 1.5rem rgba(0,0,0,0.3);
  display: flex;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
}

.login-form {
  flex: 1 1 300px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 2.5rem 1.5rem;
}

.text-center {
  text-align: center;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.logo {
  max-height: 80px;
  width: auto;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.login-form h2 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  text-align: center;
  color: black;
  font-weight: 400;
}

.subtitle {
  text-align: center;
  color: #666;
  margin-bottom: 1.5rem;
  font-size: 1.2;
}

.form-group {
  margin-bottom: 1rem;
}

.form-label {
  display: block;
  font-weight: 300;
  margin-bottom: 0.5rem;
}

.form-control {
  width: 100%;
  border-radius: 4px;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  outline: none;
  border-color: #800000;
  box-shadow: 0 0 0 0.2rem rgba(19, 44, 90, 0.25);
  background: rgba(255, 255, 255, 0.95);
}

.form-control::placeholder {
  color: #132c5a;
  opacity: 0.7;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-left: 21px;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-check-input {
  width: 16px;
  height: 16px;
  accent-color: #132c5a;
}

.form-check-label {
  color: #666;
  font-size: 0.9rem;
  cursor: pointer;
}

.forgot-link,
.signup-link {
  color: #800000;
  text-decoration: none;
  font-weight: 300;
  font-size: 0.9rem;
}

.forgot-link:hover,
.signup-link:hover {
  color: #800000;
  text-decoration: underline;
}

.btn-primary {
  background-color: #800000;
  border: none;
  color: #fff;
  width: 100%;
  padding: 0.75rem;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: 300;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 1rem;
}

.btn-primary:hover:not(:disabled) {
  background-color: #800000;
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.signup-text {
  text-align: center;
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

.info-panel {
  flex: 1.2 1 300px;
  background-color: #800000;
  color: #fff;
  padding: 2.5rem 1.5rem;
}

.info-panel h3 {
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
  font-weight: 300;
  color: #fff;
}

.info-panel p {
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  opacity: 0.9;
}

.video-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 */
  border-radius: 0.5rem;
  overflow: hidden;
  background: #333;
}

.video-wrapper img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: rgba(255,255,255,0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
}

.play-btn:hover {
  background: rgba(255,255,255,1);
  transform: translate(-50%, -50%) scale(1.1);
}

.play-icon {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 12px 0 12px 20px;
  border-color: transparent transparent transparent #132c5a;
  margin-left: 4px;
}

/* Custom Modal Styles */
.video-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.video-modal-content {
  position: relative;
  width: 100%;
  max-width: 800px;
  background: transparent;
  border-radius: 0.5rem;
  overflow: hidden;
}

.modal-close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  z-index: 1001;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close-btn:hover {
  opacity: 0.7;
}

.video-container {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 */
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0.5rem;
}

.alert {
  padding: 0.75rem 1rem;
  margin-top: 1rem;
  border-radius: 0.25rem;
}

.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

@media (max-width: 767px) {
  .info-panel {
    margin-top: 1rem;
    order: 1;
  }

  .login-form,
  .info-panel {
    padding: 1.5rem 1rem;
  }

  .login-wrapper {
    padding: 0.5rem;
  }

  .form-options {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
}

@media (max-width: 576px) {
  .login-form h2 {
    font-size: 1.25rem;
  }

  .logo {
    max-height: 50px;
  }

  .video-modal-content {
    margin: 0 0.5rem;
  }

  .modal-close-btn {
    top: -35px;
    font-size: 1.5rem;
  }
}
</style>
